import { render, staticRenderFns } from "./CaregiversList.vue?vue&type=template&id=caaeec94&"
import script from "./CaregiversList.vue?vue&type=script&lang=js&"
export * from "./CaregiversList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports